/** saves list of policies
@payload { Array }
*/
export const SAVE_POLICIES_LIST = (state, payload) => {
	state.policiesList = payload
}

/** saves policy receipts list
@payload { Array }
*/
export const SAVE_POLICY_RECEIPTS_LIST = (state, payload) => {
	state.policyReceiptsList = payload
}

/*************************************************
*                  CLEAR MUTATIONS               *
*************************************************/
export const CLEAR_FEATURE_STATE = (state, payload) => {
	state.policiesList = []
}
